import { render, staticRenderFns } from "./referential-bank.vue?vue&type=template&id=2fbdb758&"
import script from "./referential-bank.vue?vue&type=script&lang=ts&"
export * from "./referential-bank.vue?vue&type=script&lang=ts&"
import style0 from "./referential-bank.vue?vue&type=style&index=0&id=2fbdb758&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports